"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeArrayLikeProxy = void 0;
function makeArrayLikeProxy(arr, isValidElem, initModifyElem, modifyElem) {
    var like = {};
    Object.defineProperty(like, "length", {
        value: arr.length,
        writable: false,
        enumerable: false,
        configurable: false
    });
    var clonedArr = Array.from(arr);
    var _loop_1 = function (i) {
        clonedArr[i] = initModifyElem(arr[i]);
        Object.defineProperty(like, i, {
            get: function () { return clonedArr[i]; },
            set: function (newElem) {
                if (isValidElem(newElem))
                    clonedArr[i] = modifyElem(newElem, clonedArr[i]);
                return newElem;
            },
            enumerable: true,
            configurable: false
        });
    };
    for (var i = 0; i < arr.length; i++) {
        _loop_1(i);
    }
    return like;
}
exports.makeArrayLikeProxy = makeArrayLikeProxy;
